import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { IoHomeOutline, IoHomeSharp, IoPricetag, IoPricetagOutline } from "react-icons/io5";
import { IoStorefrontOutline, IoStorefrontSharp } from "react-icons/io5";
import { VscDashboard } from "react-icons/vsc";
import { RiAccountCircleLine } from "react-icons/ri";
import { RiKeyboardBoxLine, RiKeyboardBoxFill } from "react-icons/ri";
import { googleLogout, checkUserAuth } from '../firebase';
import Cookies from 'js-cookie';
import Photosicon from '../assets/photos_icon.png';
import "./Navbar.css";
import { MdApps, MdCall, MdOutlineReceiptLong, MdReceipt } from 'react-icons/md';
import { BsPersonVideo2 } from "react-icons/bs";
export default function Navbar() {
  const location = useLocation(); // Get current route
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [userlogin, setuserlogin] = useState(false);
  useEffect(() => {
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setGuid(existingUser);
      setuserlogin(true);
      const photo = Cookies.get("login_photoURL");

      setPhotoURL(photo);
    } else {
      setuserlogin(false);
    }
  }, []);
  // const handleGoogleLogin = async () => {
  //   const userData = await signInWithGoogle();
  //   setUser(userData);
  //   setTimeout(() => window.location.reload(), 2000);
  // };


  return (
    <nav className="navbar">
      <div
        onClick={() => navigate('/')}
        className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
        title="Home"
      >
        {location.pathname === '/' ? <IoHomeSharp className="icon" /> : <IoHomeOutline className="icon" />}
        <span className="button-text">Home</span>
      </div>

      {/* <div
        onClick={() => navigate('/ads')}
        className={`menubutton-icon ${location.pathname === '/ads' ? 'active' : ''}`}
        title="Home"
      >
        {location.pathname === '/ads' ? <BsPersonVideo2 className="icon" /> : <BsPersonVideo2 className="icon" />}
        <span className="button-text">Ads</span>
      </div>
              */}

      <div
        onClick={() => navigate('/pos-receipt')}
        className={`menubutton-icon ${location.pathname === '/pos-receipt' ? 'active' : ''}`}
        title="POS Receipt"
      >
        {location.pathname === '/pos-receipt' ? <MdOutlineReceiptLong className="icon" /> : <MdOutlineReceiptLong className="icon" />}
        <span className="button-text">POS Receipt</span>
      </div>
   <div
        onClick={() => navigate('/pricing')}
        className={`menubutton-icon ${location.pathname === '/pricing' ? 'active' : ''}`}
        title="Pricing"
      >
        {location.pathname === '/pricing' ? <IoPricetag className="icon" /> : <IoPricetagOutline className="icon" />}
        <span className="button-text">Pricing</span>
      </div>

      <div 
        className={`menubutton-icon ${location.pathname === '/dashboard' ? 'active' : ''}`}
        title="dashboard"
      >
        {userlogin == true && (
          <img
          onClick={() => window.location.href = 'https://aooz.in/account?return=https://accounting.aooz.in'}
            src={Cookies.get("login_photoURL") || Photosicon}
            onError={(e) => { e.currentTarget.src = Photosicon; }}
            className="img-icon rounded-circle shadow hover"
          />

        )}
        {userlogin == false && (
        <div className='login_button' onClick={() => window.location.href = "https://aooz.in/login?return=https://accounting.aooz.in"}>
           <RiAccountCircleLine className="icon" />
           </div>
       
        )}
      </div>
    </nav>
  );
};